import { render, staticRenderFns } from "./restaurant.vue?vue&type=template&id=0435396b&scoped=true"
import script from "./restaurant.vue?vue&type=script&lang=ts"
export * from "./restaurant.vue?vue&type=script&lang=ts"
import style0 from "./restaurant.vue?vue&type=style&index=0&id=0435396b&prod&lang=css"
import style1 from "./restaurant.vue?vue&type=style&index=1&id=0435396b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0435396b",
  null
  
)

export default component.exports